<div class="{{ className }}">
  <div class="{{ className }}__wrapper" tabindex="0">
    <table
      (matSortChange)="storeSort($event, view)"
      [dataSource]="dataSource"
      [matSortActive]="matSortActive"
      [matSortDirection]="matSortDirection"
      [style.border-radius]="borderRadius ? borderRadius : ''"
      [style.box-shadow]="boxShadow ? boxShadow : ''"
      class="without-scroll {{ borderRadius ? 'radius' : '' }}"
      id="table{{ view }}"
      mat-table
      matSort>
      <ng-container *ngFor="let data of dataTable; let i = index" [matColumnDef]="data.colData">
        <!--check2 llama directamente a un servicio no se pueden marcar todas las filas de golpe-->
        <ng-container *ngIf="data.colType === 'check2'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-header-cell>
            <span
              [style.max-width]="data.width ?? 'auto'"
              class="ellipsis"
              matTooltip="{{ data.labels }}"
              matTooltipClass="{{ theme }} custom-tooltip"
              matTooltipPosition="before">
              {{ data.labels }}
            </span>
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <mat-checkbox
              (change)="emitActions(element, data.textAction)"
              (click)="$event.stopPropagation()"
              [(ngModel)]="element[data.colData]"
              [checked]="element[data.colData]"
              [labelPosition]="'before'"
              [style.display]="data.showCol ? 'table-cell' : 'none'"
              [style.width]="data.width ?? 'auto'"
              class="{{ className }}__td-{{ i }}  {{
                data.align ? className + '__' + data.align : ''
              }}"
              color="purple"
              id="table{{ view }}-checkbox2-{{ data.colData }}-{{ element._id }}">
            </mat-checkbox>
          </td>
        </ng-container>
        <!--link-->
        <ng-container *ngIf="data.colType === 'link'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.max-width]="data.width ?? 'auto'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            disableClear
            mat-header-cell
            mat-sort-header>
            <span
              [style.max-width]="data.width ?? 'auto'"
              class="ellipsis"
              matTooltip="{{ data.labels }}"
              matTooltipClass="{{ theme }} custom-tooltip"
              matTooltipPosition="before"
              >{{ data.labels }}</span
            >
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <span
              (click)="emitActions(element, 'detail')"
              [style.max-width]="data.width ?? 'auto'"
              class="{{ className }}__link ellipsis"
              id="table{{ view }}-link-detail-{{ element._id }}"
              matTooltip="{{ element[data.colData] }}"
              matTooltipClass="{{ theme }} custom-tooltip"
              matTooltipPosition="before">
              {{ element[data.colData] }}
            </span>
          </td>
        </ng-container>
        <!--img-->
        <ng-container *ngIf="data.colType === 'img'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-header-cell>
            {{ data.labels }}
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <div *ngIf="data.colData === 'avatar'" class="{{ className }}__avatar">
              <img
                alt="avatar"
                src="{{
                  element.avatar !== '' ? element.avatar : 'assets/images/avatars/profile.jpg'
                }}" />
            </div>
          </td>
        </ng-container>
        <!--icon & iconType-->
        <ng-container *ngIf="data.colType === 'icon' && data.colData === 'iconType'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            disableClear
            mat-header-cell
            mat-sort-header>
            {{ data.labels }}
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <span class="{{ className }}__wrapper-icon">
              <img
                *ngIf="element.iconType === 'market'"
                class="{{ data.icon[0].customClassIcon }} {{ className }}__icon-svg"
                matTooltip="{{ data.icon[0].labelsTooltip }}"
                matTooltipClass="{{ theme }} custom-tooltip"
                matTooltipPosition="before"
                src="{{ data.icon[0].iconName }}" />
              <img
                *ngIf="element.iconType === 'native'"
                class="{{ data.icon[1].customClassIcon }} {{ className }}__icon-svg"
                matTooltip="{{ data.icon[1].labelsTooltip }}"
                matTooltipClass="{{ theme }} custom-tooltip"
                matTooltipPosition="before"
                src="{{ data.icon[1].iconName }}" />
              <img
                *ngIf="element.iconType === 'docker'"
                class="{{ data.icon[2].customClassIcon }} {{ className }}__icon-svg"
                matTooltip="{{ data.icon[2].labelsTooltip }}"
                matTooltipClass="{{ theme }} custom-tooltip"
                matTooltipPosition="before"
                src="{{ data.icon[2].iconName }}" />
            </span>
          </td>
        </ng-container>
        <!--icon & alive || deviceAlive-->
        <ng-container
          *ngIf="
            data.colType === 'icon' && (data.colData === 'alive' || data.colData === 'deviceAlive')
          ">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            disableClear
            mat-header-cell
            mat-sort-header>
            {{ data.labels }}
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <span [style]="'margin-right:20px'" class="{{ className }}__wrapper-icon">
              <mat-icon
                class="{{
                  element.alive || element.deviceAlive
                    ? data.icon[0].customClassIcon
                    : data.icon[1].customClassIcon
                }} {{ className }}__icon"
                matTooltip="{{
                  element.alive || element.deviceAlive
                    ? data.icon[0].labelsTooltip
                    : data.icon[1].labelsTooltip
                }}"
                matTooltipClass="{{ theme }} custom-tooltip"
                matTooltipPosition="before"
                >{{
                  element.alive || element.deviceAlive
                    ? data.icon[0].iconName
                    : data.icon[1].iconName
                }}
              </mat-icon>
            </span>
          </td>
        </ng-container>
        <!--icon & !alive && !deviceAlive && !iconType-->
        <ng-container
          *ngIf="
            data.colType === 'icon' &&
            data.colData !== 'iconType' &&
            data.colData !== 'alive' &&
            data.colData !== 'deviceAlive'
          ">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-header-cell>
            {{ data.labels }}
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <ng-container *ngFor="let icon of data.icon">
              <span
                *ngIf="icon.iconData && icon.iconDisabled"
                class="{{ className }}__wrapper-icon">
                <mat-icon
                  class="{{ icon.customClassIcon }} {{ className }}__icon{{
                    !element.icons[icon.iconDisabled] ? '-disabled' : ''
                  }}"
                  matTooltip="{{ icon.labelsTooltip }}"
                  matTooltipClass="{{ theme }} custom-tooltip"
                  matTooltipPosition="before"
                  >{{ icon.iconName }}
                </mat-icon>
              </span>
            </ng-container>
          </td>
        </ng-container>
        <!--running-->
        <ng-container *ngIf="data.colType === 'running'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            disableClear
            mat-header-cell
            mat-sort-header>
            {{ data.labels }}
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <ng-container *ngIf="element.runningApps > 0">
              <span>
                {{ element.runningApps + ' of ' + element.installedApps }}
              </span>
            </ng-container>
          </td>
        </ng-container>
        <!--tags-->
        <!--text-->
        <ng-container *ngIf="data.colType === 'text'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.max-width]="data.width ?? 'auto'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            disableClear
            mat-header-cell
            mat-sort-header>
            <span
              [style.max-width]="data.width ?? 'auto'"
              class="ellipsis {{ data.align ? className + '__' + data.align : '' }}"
              matTooltip="{{ data.labels }}"
              matTooltipClass="{{ theme }} custom-tooltip"
              matTooltipPosition="before"
              >{{ data.labels }}</span
            >
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            id="{{ className }}__td-{{ utilService.removeSpacesAndInsertScript(element.name) }}"
            mat-cell>
            <span
              [style.max-width]="data.width ?? 'auto'"
              class="ellipsis"
              matTooltip="{{ element[data.colData] }}"
              matTooltipClass="{{ theme }} custom-tooltip"
              matTooltipPosition="before"
              >{{ element[data.colData] }}</span
            >
          </td>
        </ng-container>
        <!--text-icon-->
        <ng-container *ngIf="data.colType === 'text-icon'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            disableClear
            mat-header-cell
            mat-sort-header>
            {{ data.labels }}
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <div class="{{ className }}__text-icon">
              <span
                matTooltip="{{ element[data.colData] }}"
                matTooltipClass="{{ theme }} custom-tooltip"
                matTooltipPosition="before"
                >{{ element[data.colData] }}
              </span>
              <mat-icon
                *ngIf="element.updateAvailable !== ''"
                [style.font-size]="data.iconText.fontSize !== '' ? data.iconText.fontSize : ''"
                [style.height]="data.iconText.fontSize !== '' ? data.iconText.fontSize : ''"
                [style.line-height]="data.iconText.fontSize !== '' ? data.iconText.fontSize : ''"
                [style.width]="data.iconText.fontSize !== '' ? data.iconText.fontSize : ''"
                class="material-icons-oultined {{ className }}__text-icon-icon"
                color="{{ data.iconText.color !== '' ? data.iconText.color : 'primary' }}"
                matTooltip="{{ data.iconText.labelsTooltip }}"
                matTooltipClass="{{ theme }} custom-tooltip"
                matTooltipPosition="after"
                >{{ data.iconText.iconName }}
              </mat-icon>
            </div>
          </td>
        </ng-container>
        <!--pipe-->
        <ng-container *ngIf="data.colType === 'pipe'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            disableClear
            mat-header-cell
            mat-sort-header>
            {{ data.labels }}
          </th>
          <td
            *matCellDef="let element"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <span>
              {{
                data.pipe === 'uppercase'
                  ? (element[data.colData] | uppercase)
                  : data.pipe === 'architectures'
                    ? (element[data.colData] | architectures)
                    : data.pipe === 'persist'
                      ? (element[data.colData] | persist)
                      : data.pipe === 'date' && element[data.colData] !== ''
                        ? (element[data.colData] | date: 'd/M/yy, h:mm a') === '1/1/70, 1:00 AM'
                          ? 'Never Seen'
                          : (element[data.colData] | date: 'd/M/yy, h:mm a')
                        : 'Online'
              }}
            </span>
          </td>
        </ng-container>
        <!--button-->
        <ng-container *ngIf="data.colType === 'button'">
          <th
            *matHeaderCellDef
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.max-width]="data.width ?? 'auto'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__th-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-header-cell>
            <span
              class="ellipsis"
              matTooltip="{{ data.labels }}"
              matTooltipClass="{{ theme }} custom-tooltip"
              matTooltipPosition="before"
              >{{ data.labels }}</span
            >
          </th>
          <td
            *matCellDef="let element; let k = index"
            [style.display]="data.showCol ? 'table-cell' : 'none'"
            [style.width]="data.width ?? 'auto'"
            class="{{ className }}__td-{{ i }}  {{
              data.align ? className + '__' + data.align : ''
            }}"
            mat-cell>
            <!-- status === 1   PROGRESS BAR-->
            <ng-container *ngIf="data.actions && element.status === 1">
              <div class="progress-bar">
                <mat-progress-bar
                  class="progress-bar"
                  color="primary"
                  mode="indeterminate"></mat-progress-bar>
              </div>
            </ng-container>
            <!-- status === 2   actions.actionType === 'update' -->
            <ng-container *ngIf="data.actions && element.status === 2">
              <ng-container *ngFor="let actions of data.actions">
                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="
                    actions.showButton &&
                    element.name !== 'Default' &&
                    element.type !== 'marketplace ' &&
                    actions.actionType === 'update'
                  "
                  [disabled]="element.updateAvailable === ''"
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{ actions.icon.labelsTooltip }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{ actions.icon.iconName }}
                  </mat-icon>
                </button>
                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="
                    actions.showButton &&
                    element.name !== 'Default' &&
                    element.type !== 'marketplace' &&
                    actions.actionType !== 'update'
                  "
                  [disabled]="actions.disabledButton"
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{ actions.icon.labelsTooltip }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{ actions.icon.iconName }}
                  </mat-icon>
                </button>
              </ng-container>
            </ng-container>
            <!-- sin status -->
            <ng-container *ngIf="data.actions && !element.status">
              <ng-container *ngFor="let actions of data.actions">
                <!-- BOTONES GRUPO DEFAULT -->

                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="actions.showButton && element.name === 'Default'"
                  [disabled]="element.companyId.length > 0 && actions.actionType === 'delete'"
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{ actions.icon.labelsTooltip }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{ actions.icon.iconName }}
                  </mat-icon>
                </button>
                <!-- BOTONES MARKETPLACE -->
                <!-- Botón enable/disable app -->
                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="actions.icon.iconName === 'visibility'"
                  [disabled]="
                    element[actions.disabledByData[0]] === 0 &&
                    element[actions.disabledByData[1]].length === 0 &&
                    element[actions.disabledByData[2]] === 'Private'
                  "
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{
                      element.enabled === 'Visible' ? this.labels.hide : actions.icon.labelsTooltip
                    }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{
                      actions.icon.iconName === 'visibility' && element.enabled === 'Visible'
                        ? 'visibility_off'
                        : actions.icon.iconName
                    }}
                  </mat-icon>
                </button>
                <!-- Botón añadir versión app -->
                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="actions.icon.iconName === 'app_registration'"
                  [disabled]="element[actions.disabledByData[2]] === 'Public'"
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{ actions.icon.labelsTooltip }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{ actions.icon.iconName }}
                  </mat-icon>
                </button>
                <!-- BOTONES PLAY/STOP -->

                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="
                    (actions.showButton && actions.actionType === 'play') ||
                    (actions.showButton && actions.actionType === 'stop')
                  "
                  [disabled]="
                    (element.run && actions.actionType === 'play') ||
                    (!element.run && element.waiting && actions.actionType === 'play') ||
                    (!element.run && actions.actionType === 'stop') ||
                    (element.run && element.waiting && actions.actionType === 'stop')
                  "
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{ actions.icon.labelsTooltip }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{ actions.icon.iconName }}
                  </mat-icon>
                </button>
                <!-- BOTON LOGS -->
                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="actions.showButton && actions.actionType === 'logs'"
                  [disabled]="element.disableLogButton"
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{ actions.icon.labelsTooltip }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{ actions.icon.iconName }}
                  </mat-icon>
                </button>
                <!-- RESTO DE BOTONES -->
                <!-- delete-category -->
                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="actions.showButton && actions.actionType === 'delete-category'"
                  [disabled]="
                    element.type === 'Purchased' ||
                    element.type === 'Most_Purchased' ||
                    element.type === 'Featured' ||
                    element.type === 'Special' ||
                    element.type === 'Suggested'
                  "
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{ actions.icon.labelsTooltip }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{ actions.icon.iconName }}
                  </mat-icon>
                </button>
                <!-- delete apps -->
                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="
                    actions.showButton &&
                    element.name !== 'Default' &&
                    element.type !== 'marketplace' &&
                    actions.actionType !== 'play' &&
                    actions.actionType !== 'stop' &&
                    actions.actionType !== 'logs' &&
                    actions.actionType !== 'delete-category' &&
                    actions.icon.iconName !== 'visibility' &&
                    actions.icon.iconName !== 'app_registration'
                  "
                  [disabled]="
                    actions.disabledButton ||
                    (element?.companyIds?.length > 0 && actions.actionType === 'delete')
                  "
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{ actions.icon.labelsTooltip }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{ actions.icon.iconName }}
                  </mat-icon>
                </button>
              </ng-container>
            </ng-container>
            <!-- columna Network OS Image -->
            <ng-container *ngIf="element.actions2">
              <ng-container *ngFor="let actions of data.actions2">
                <button
                  (click)="emitActions(element, actions.actionType)"
                  *ngIf="element.actions2.includes(actions.actionType)"
                  id="table{{ view }}-button-{{ actions.actionType }}-{{
                    utilService.removeSpacesAndInsertScript(element.name)
                  }}"
                  mat-icon-button>
                  <mat-icon
                    class="material-icons-oultined {{ className }}__icon"
                    matTooltip="{{ actions.icon.labelsTooltip }}"
                    matTooltipClass="{{ theme }} custom-tooltip"
                    matTooltipPosition="before"
                    >{{ actions.icon.iconName }}
                  </mat-icon>
                </button>
              </ng-container>
            </ng-container>
          </td>
        </ng-container>
      </ng-container>

      <ng-container matColumnDef="nodata">
        <td
          *matFooterCellDef
          [colSpan]="displayedColumns.length"
          class="no-data"
          mat-cell
          mat-footer-cell>
          {{ noDataLabel ?? 'No data found' }}
        </td>
      </ng-container>
      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns; let k = index" mat-row></tr>
      <tr *matFooterRowDef="['nodata']" [hidden]="dataSource.data.length > 0" mat-footer-row></tr>
    </table>
  </div>
</div>
<!--[disabled]="actions.icon.iconName === 'visibility' ? false : element.marketplace"-->